import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import AddUsers from "../componets/AddUsers";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import TextInput from "../componets/TextInput";
import { Toast } from "primereact/toast";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { formatDateTime } from "../config/Config";
import { formatDate } from "../config/Config";
import { Dropdown } from "primereact/dropdown";
import { permissionLookUp } from "./../constants";

// import { ConfirmDialog } from 'primereact/confirmdialog'; // For <ConfirmDialog /> component
// import { confirmDialog } from 'primereact/confirmdialog'; // For confirmDialog method

import RegistrationDelimitationSelector from "../componets/RegistrationDelimitationSelector";
import UserGroupSelector from "../componets/UserGroupSelector";
import { usersService } from "../services/UsersService";
import { delimitationService } from "../services/DelimitationService";
import { UserGroupHistory } from "./users/UserGroupsHistory";
import { UserDelimitationHistory } from "./users/UserDelimitationHistory";
import { UserGroups } from "./users/UserGroups";
import { UserDelimitationView } from "./users/UserDelimitationView";
import { AppDB } from "../App";
import { PickList } from "primereact/picklist";
import { userGroupsService } from "../services/UserGroupsService";
import ScreenLoader from "../componets/ScreenLoader";
import { changeLang } from "../componets/Language/ChangeLang";
import OfficeSelector from "../componets/OfficeSelector";
import { get } from "sortablejs";

export const Users = () => {
	var { permission, toast, userDetails } = useContext(AppDB);
	const [showAddUserForm, setShowAddUserForm] = useState(false);
	const [showEditUserForm, setShowEditUserForm] = useState(false);
	const [showViewDialog, setShowViewDialog] = useState(false);
	const [showRegistrionCentreSelector, setShowRegistrionCentreSelector] = useState(false);
	const [showRUserGroupSelector, setShowUserGroupSelector] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadingGroup, setLoadingGroup] = useState(true);
	const [groups, setGroups] = useState([]);

	let [userData, setUserData] = useState([]);

	const [selectedUsers, setSelectedUsers] = useState(null);
	const [selectedUser, setSelectedUser] = useState(null);
	const [showOfficeSelector, setShowOfficeSelector] = useState(false);

	var updatedDelimtation = {};

	var [delimitations, setDelimitations] = useState([]);
	var [offices, setOffices] = useState([]);

	const [target, setTarget] = useState([]);
	var [systemGroupsList, setSystemGroupsList] = useState([]);
	var [selectedGroup, setSelectedGroup] = useState("");
	const onUserGroupChange = (event) => {
		if (!(target.length == 0 && event.target.length > 1) && (target.length < 1 || event.source.length > systemGroupsList.length)) {
			setSelectedGroup(event?.target[0]?.groupID || "");
			setSystemGroupsList(event.source.sort((a, b) => a.name.localeCompare(b.name)));
			setTarget(event.target);
		} else {
			return toast.current.show({
				severity: "warn",
				summary: "Multiple groups denied",
				detail: "Only one user group allowed per user.",
				life: 3000
			});
		}
	};

	const header = (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">Users</h5>
		</div>
	);

	async function getGroups(userId) {
		setLoadingGroup(true);
		var data = await usersService.getGroups(userId);
		var response = await userGroupsService.getAll();

		var selectGroups = [];
		data.forEach((element) => {
			let group = response.find((x) => x.groupID == element.groupID);
			if (group) {
				selectGroups.push(group);
				response.splice(response.indexOf(group), 1);
			}
		});
		setGroups(data);
		setSystemGroupsList(response);
		setTarget(selectGroups);
		setLoadingGroup(false);
	}

	function getDelimitations(userId) {
		setLoading(true);
		usersService
			.getDelimitations(userId)
			.then((data) => {
				setLoading(false);
				data.forEach((element) => {
					if (element.delimitationLevelID == 1) {
						element.constituencyName = "All";
						element.pollingDivisionName = "All";
						element.registrationCentreName = "All";
					} else if (element.delimitationLevelID == 2) {
						element.pollingDivisionName = "All";
						element.registrationCentreName = "All";
					} else if (element.delimitationLevelID == 3) {
						element.registrationCentreName = "All";
					}
				});
				setDelimitations(data);
			})
			.catch((error) => {
				console.error("Error fetching delimitations:", error);
				setLoading(false);
			});
	}

	const [inOffice, setInOffice] = useState(false);
	function getOffices(userId) {
		setLoading(true);
		usersService
			.getOffices(userId)
			.then((data) => {
				setLoading(false);
				console.log("Office data :", data)
				setOffices(data);
				setInOffice(true);
				if (data.status === 204) {
					setInOffice(false);
				}
			})
			.catch((error) => {
				console.error("Error fetching delimitations:", error);
				setLoading(false);
			});
	}

	
	console.log("Hello World")
	function userRowData() {
		return [
			{
				col1: "First Name",
				col2: selectedUser?.appointment?.firstName,
				col3: "Surname",
				col4: selectedUser?.appointment?.surname
			},
			{
				col1: "Other Names",
				col2: selectedUser?.appointment?.otherNames,
				col3: "Gender",
				col4: selectedUser?.appointment?.gender
			},
			{
				col1: "Date Of Birth",
				col2: formatDate(selectedUser?.appointment?.dateOfBirth),
				col3: "ID Number",
				col4: selectedUser?.appointment?.idCardNumber
			},
			{
				col1: "Postal Address",
				col2: selectedUser?.appointment?.postalAddress,
				col3: "Residential Address",
				col4: selectedUser?.appointment?.residentialAddress
			},
			{
				col1: "Phone Number",
				col2: selectedUser?.appointment?.phoneNumber,
				col3: "Mobile Number",
				col4: selectedUser?.appointment?.mobileNumber
			},
			{
				col1: "Email Address",
				col2: selectedUser?.appointment?.emailAddress,
				col3: "",
				col4: ""
			},
			{
				col1: "Position",
				col2: selectedUser?.appointment?.position,
				col3: "Employed Date",
				col4: formatDate(selectedUser?.appointment?.dateEmployed)
			},
			{
				col1: "Created Date",
				col2: formatDateTime(selectedUser?.appointment?.createdDate),
				col3: "Created By",
				col4: selectedUser?.appointment?.createdBy
			},
			{
				col1: "Updated Date",
				col2: selectedUser?.appointment?.updatedDate ? formatDate(selectedUser?.appointment?.updatedDate) : "",
				col3: "Updated By",
				col4: selectedUser?.appointment?.updatedBy
			},
			{
				col1: "Revoked Date",
				col2: selectedUser?.appointment?.dateRevoked ? formatDateTime(selectedUser?.appointment?.dateRevoked) : "",
				col3: "",
				col4: ""
			}
		];
	}

	var [district, setDistrict] = useState([]);
	const [selectedDistrict, setSelectedDistrict] = useState(null);

	var [centre, setCentre] = useState([]);
	const [selectedCentre, setSelectedCentre] = useState(null);
	const [filters, setFilters] = useState({
		global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		name: {
			operator: FilterOperator.AND,
			constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
		}
	});

	useEffect(() => {
		GetAll();

		delimitationService.getDistricts().then((data) => {
			setDistrict(data);
		});
		// registrationService.getRegistrationCentres().then((data) => {
		// 	setCentre(data);
		// });
	}, []);

	function GetAll() {
		setLoading(true);
		usersService
			.getAll()
			.then((data) => {
				console.log("Users --------->");
				console.log(data);
				setUserData(data);
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);

				return toast.current.show({
					severity: "error",
					summary: "Changes not saved.",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}
	function activateHandler(id) {
		usersService.activateUser(id).then((res) => {
			GetAll();
		});
	}

	function deActivateHandler(id) {
		usersService.deActivateUser(id).then((res) => {
			usersService.getAllUsers().then((data) => {
				console.log(data);
				setUserData(data);
			});
		});
	}
	const confirmDeleteDelimitation = (e, grouDelimitation) => {
		confirmDialog({
			message: "Are you sure you want to delete this item?",
			header: grouDelimitation ? "Delete User Group" : "Delete User Demarcation",
			icon: "pi pi-exclamation-triangle",
			accept: () => deleteDelimitation(e, grouDelimitation),
			reject: () => { }
		});
	};

	const confirmDeleteOffice = (e) => {
		confirmDialog({
			message: "Are you sure you want to delete this item?",
			header: "Delete Office",
			icon: "pi pi-exclamation-triangle",
			accept: () => deleteOffice(e),
			reject: () => { }
		});
	};

	function GetDelimitationId(e) {
		return e.delimitationLevelID == 1
			? e?.districtID
			: e?.delimitationLevelID == 2
				? e?.constituencyID
				: e?.delimitationLevelID == 3
					? e?.pollingDivisionID
					: e?.registrationCentreID;
	}
	function deleteDelimitation(e, isGroupDelimitation) {
		if (isGroupDelimitation) {
			DeleteUserGroupDelimitation(e);
		} else {
			deleteUserDelimitation(e);
		}
	}
	function deleteOffice(e) {
		usersService.deactivateUserOfficer(e)
			.then((response) => {
							getOffices(selectedUser.userID);

				if (response.success) {
					getOffices(selectedUser.userID);
					setShowOfficeSelector(false);
					return toast.current.show({
						severity: "success",
						summary: "Office deleted",
						detail: "User Office deleted",
						life: 3000
					});
				} else {
					return toast.current.show({
						severity: "info",
						summary: "Changes not saved.",
						detail: "Ooops, The is a technical problem,Please Try Again",
						life: 3000
					});
				}
			}).catch((err) => {
				return toast.current.show({
					severity: "error",
					summary: "Changes not saved.",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}
	function DeleteUserGroupDelimitation(e) {
		usersService
			.deleteUserGoupDelimitation(e)
			.then((response) => {
				if (response.success) {
					getGroups(selectedUser.userID);
					setShowUserGroupSelector(false);
					return toast.current.show({
						severity: "success",
						summary: "Demarcation deleted",
						detail: "User group deleted",
						life: 3000
					});
				} else {
					return toast.current.show({
						severity: "info",
						summary: "Changes not saved.",
						detail: "Ooops, The is a technical problem,Please Try Again",
						life: 3000
					});
				}
			})
			.catch((err) => {
				return toast.current.show({
					severity: "error",
					summary: "Changes not saved.",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}
	function deleteUserDelimitation(e) {
		usersService
			.deleteUserDelimitation({
				UserID: selectedUser?.userID,
				DelimitationID: GetDelimitationId(e),
				DelimitationLevelID: e.delimitationLevelID,
				CreatedBy: userDetails?.userID
			})
			.then((data) => {
				if (data.success) {
					getDelimitations(selectedUser?.userID);
					return toast.current.show({
						severity: "success",
						summary: "Demarcation deleted",
						detail: "User delimitation deleted",
						life: 3000
					});

				} else {
					return toast.current.show({
						severity: "info",
						summary: "Changes not saved.",
						detail: "Ooops, The is a technical problem,Please Try Again",
						life: 3000
					});
				}
			})
			.catch((e) => {
				return toast.current.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}

	function deactivateUserOffice(e) {
		usersService
			.deactivateUserOfficer({
				UserID: selectedUser?.userID,
				DelimitationID: GetDelimitationId(e),
				DelimitationLevelID: e.delimitationLevelID,
				CreatedBy: userDetails?.userID
			})
			.then((data) => {
				if (data.success) {
					getOffices(selectedUser?.userID);
					return toast.current.show({
						severity: "success",
						summary: "Office deactivated",
						detail: "Office User deactivated",
						life: 3000
					});

				} else {
					return toast.current.show({
						severity: "info",
						summary: "Changes not saved.",
						detail: "Ooops, The is a technical problem,Please Try Again",
						life: 3000
					});
				}
			})
			.catch((e) => {
				return toast.current.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}

	function isValid() {
		return !selectedGroup && target.length > 0;
	}
	function onUserGroupSelector() {
		if (selectedGroup) {
			if (permission?.actions?.includes(permissionLookUp?.Create) || permission?.actions?.includes(permissionLookUp?.Update)) {
				usersService
					.createUserGroup({
						GroupID: selectedGroup,
						UserID: selectedUser.userID
					})
					.then((response) => {
						if (response?.success) {
							getGroups(selectedUser.userID);
							return toast.current.show({
								severity: "success",
								summary: "SUCCESS",
								detail: "Records updated.",
								life: 3000
							});
						} else {
							return toast.current.show({
								severity: "info",
								summary: "Changes not saved.",
								detail: "No changes made.",
								life: 3000
							});
						}
					})
					.catch((err) => {
						return toast.current.show({
							severity: "error",
							summary: "Changes not saved.",
							detail: "Something went wrong while processing your request.",
							life: 3000
						});

					});
			}
			else {
				UnAuthorizedAlert();
			}
		}
		else if (groups.length > 0) {
			if (permission?.actions?.includes(permissionLookUp?.Delete)) {
				confirmDeleteDelimitation(groups[0], true);
			}
			else {
				UnAuthorizedAlert();
			}
		}
		else {
			return toast.current.show({
				severity: "info",
				summary: "No Changes",
				detail: "No changes made.",
				life: 3000
			});
		}
	}
	function UnAuthorizedAlert() {
		return toast.current.show({
			severity: "warn",
			summary: "Unauthorized.",
			detail: "You are not authorized to perform this action.",
			life: 5000
		});
	}
	function onRegistrationCentreSelected(data) {
		setShowRegistrionCentreSelector(false);

		// var model = {};
		// if (data.registrationCentre?.DelimitationID)model=data.registrationCentre;
		// else if (data.pollingDivision?.DelimitationID) model=data.pollingDivision;
		// else if (data.constituency?.DelimitationID) model=data.constituency;
		// else if (data.district?.DelimitationID) model=data.district;

		// var payload = [];
		// model.DelimitationID.forEach(id =>
		// {
		// 	payload.push({
		// 		UserID: selectedUser?.userID,
		// 		DelimitationLevelID: model.DelimitationLevelID,
		// 		DelimitationID:id
		// 	});
		// });
		setLoading(true);
		usersService
			.createDelimitation(data)
			.then((response) => {
				if (response.success) {
					getDelimitations(selectedUser?.userID);
					setLoading(false);
					return toast.current.show({
						severity: "success",
						summary: "Demarcation Saved",
						detail: response.message,
						life: 3000
					});
				} else {
					setLoading(false);
					return toast.current.show({
						severity: "info",
						summary: "Information",
						detail: response.message,
						life: 3000
					});
				}
			})
			.catch((err) => {
				setLoading(false);
				return toast.current.show({
					severity: "error",
					summary: "Failure",
					//detail: err.message,
					detail: "Something went wrong.",
					life: 3000
				});
			});
	}

	function onOfficeSelectorSubmit(data) {
		setShowOfficeSelector(false);

		setLoading(true);
		usersService
			.createOfficeUser(data)
			.then((response) => {
				if (response.success) {
					getOffices(selectedUser?.userID);
					setLoading(false);
					return toast.current.show({
						severity: "success",
						summary: "Office Saved",
						detail: response.message,
						life: 3000
					});
				} else {
					setLoading(false);
					return toast.current.show({
						severity: "info",
						summary: "Information",
						detail: response.message,
						life: 3000
					});
				}
			})
			.catch((err) => {
				setLoading(false);
				return toast.current.show({
					severity: "error",
					summary: "Failure",
					//detail: err.message,
					detail: "Something went wrong.",
					life: 3000
				});
			});
	}


	var searchCriteria = [
		{
			name: "Email",
			val: 0
		},
		{
			name: "Username",
			val: 1
		}
	];

	var [searchValue, setSearchValue] = useState("");
	var [selectedCriteria, setSelectedCriteria] = useState(searchCriteria[1]);
	function SearchUsers() {
		setLoading(true);
		if (searchValue) {
			usersService
				.getSearchAll(searchValue ?? "", selectedCriteria.val)
				.then((data) => {
					setLoading(false);
					if (data.success) {
						setUserData(data.data);
					} else {
						return toast.current.show({
							severity: "error",
							summary: "Changes not saved.",
							detail: "Ooops, The is a technical problem,Please Try Again",
							life: 3000
						});
					}
				})
				.catch((err) => {
					return toast.current.show({
						severity: "error",
						summary: "Changes not saved.",
						detail: "Ooops, The is a technical problem,Please Try Again",
						life: 3000
					});
				});
		} else {
			setLoading(false);
			usersService.getAll().then((data) => {
				setUserData(data);
			});
		}
	}

	useEffect(() => {
		if (loadingGroup == true) {
			setTarget([]);
			setSelectedGroup("");
			setSystemGroupsList([]);
			setGroups([]);
		}
	}, [loadingGroup]);
	const [activeIndex, setActiveIndex] = useState(0);
	const handleTabChange = (e) => {
		setActiveIndex(e.index);
	};

	//Implement disable button if user is already assigned the office
	console.log(offices[0] == null);
	console.log(offices);
	return (
		<div className="card  p-align-stretch vertical-container" style={{ height: "100%" }}>
			<ConfirmDialog />
			<Toast ref={toast} />
			<div className="">
				<Toolbar
					className="mb-4"
					right={
						<div>
							<span className="block mt-2 md:mt-0 p-input-icon-left">
								<i className="pi pi-search" />
								<InputText
									type="search"
									placeholder="Search By"
									value={searchValue}
									onInput={(e) => setSearchValue(e.target.value)}
									style={{ width: "280px" }}
								/>
								<Dropdown
									className="ml-4"
									optionLabel="name"
									onChange={(e) => {
										setSelectedCriteria(e.value);
									}}
									options={searchCriteria}
									value={selectedCriteria}
									style={{ width: "280px" }}
								/>

								<Button className="p-button-success ml-4" label="Search" onClick={SearchUsers} />
							</span>
						</div>
					}
				></Toolbar>
			</div>

			{/* add users */}
			<AddUsers show={showAddUserForm} setShow={setShowAddUserForm} setUserData={setUserData} />
			{/* <EditUser show={showEditUserForm} setShow={setShowEditUserForm} /> */}
			{/* end */}

			<Dialog
				draggable={false}
				onHide={(e) => setShowViewDialog(false)}
				visible={showViewDialog}
				style={{ width: "80%", height: "98vh" }}
				modal
				header={
					<>
						<i className="pi pi-eye"></i>
						<span>{` User Details -  ${selectedUser?.appointment?.surname || 'Surname'}, ${selectedUser?.appointment?.firstName || 'First Name'}  (${selectedUser?.email})`}</span>
					</>
				}
				footer={
					<div>
						<Button
							icon="pi pi-times-circle"
							label="Close"
							onClick={(e) => {
								setLoadingGroup(true);
								setShowViewDialog(false);
							}}
							className="p-button-danger"
						/>
					</div>
				}
			>
				<TabView>
					<TabPanel header="User Details">
						<DataTable
							size="small"
							scrollable={true}
							dataKey="id"
							className="datatable-responsive"
							responsiveLayout="scroll"
							resizableColumns
							columnResizeMode="expand"
							value={userRowData()}
						>
							<Column field="col1" body={(e) => <b>{e.col1}</b>}></Column>
							<Column field="col2"></Column>
							<Column field="col3" body={(e) => <b>{e.col3}</b>}></Column>
							<Column field="col4"></Column>
						</DataTable>
					</TabPanel>
					<TabPanel header="Delimitations">
						<UserDelimitationView userID={selectedUser?.userID}></UserDelimitationView>
					</TabPanel>
					<TabPanel header="Groups">
						<UserGroups userID={selectedUser?.userID}></UserGroups>
					</TabPanel>
					{/* <TabPanel header="Groups Audit">
						<UserGroupHistory userID={selectedUser?.userID}></UserGroupHistory>
					</TabPanel>
					<TabPanel header="Demarcation Audit">
						<UserDelimitationHistory userID={selectedUser?.userID}></UserDelimitationHistory>
					</TabPanel> */}
				</TabView>
			</Dialog>

			<DataTable
				size="small"
				scrollable={true}
				value={userData}
				dataKey="id"
				paginator
				rows={10}
				rowsPerPageOptions={[5, 10, 25]}
				className="datatable-responsive"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
				emptyMessage="No users found."
				header={header}
				responsiveLayout="scroll"
				selection={selectedUsers}
				onSelectionChange={(e) => setSelectedUsers(e.value)}
				resizableColumns
				columnResizeMode="expand"
				loading={loading}
			>
				<Column field="email" header="Email" sortable body={(e) => e?.email}></Column>
				<Column field="userName" header="Username" sortable body={(e) => e?.userName}></Column>

				{/* <Column header="Name & Surname " body={(e) => e?.appointment?.firstName || "" + ",  " + e?.appointment?.surname || ""}></Column> */}

				<Column
					field="active"
					header="Status"
					body={(e) =>
						e?.active ? (
							<Button label="Active" style={{ textAlign: "center", height: "30px" }} className="p-button-success p-button-rounded" />
						) : (
							<Button label="Not Active" style={{ textAlign: "center", height: "30px" }} className="p-button-danger p-button-rounded" />
						)
					}
					sortable
				></Column>
				<Column
					field="actions"
					header="Actions"
					body={(e) => (
						<>
							{(permission?.actions?.includes(permissionLookUp.Create) ||
								permission?.actions?.includes(permissionLookUp.Update) ||
								permission?.actions?.includes(permissionLookUp.Delete)) && (
								<Button
									onClick={(a) => {
										setTarget([]);
										setSelectedGroup("");
										setSystemGroupsList([]);
										setGroups([]);
										setSelectedUser(e);
										setShowEditUserForm(true);
									}}
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-pencil"}
									tooltipOptions={{ position: "top" }}
									className="p-button-primary p-button-rounded mr-2"
									tooltip="Click to Edit"
								/>
							)}
							{(permission?.actions?.includes(permissionLookUp.Create) ||
								permission?.actions?.includes(permissionLookUp.Update) ||
								permission?.actions?.includes(permissionLookUp.Read)) && (
								<Button
									onClick={(a) => {
										setShowViewDialog(true);
										setSelectedUser(e);
									}}
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-eye"}
									tooltipOptions={{ position: "top" }}
									className="p-button-primary p-button-rounded mr-2"
									tooltip="Click to View"
								/>
							)}
							{/* {e.user?.active? (
								<Button
									onClick={(a) => deActivateHandler(e?.appointment?.user?.id)}
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-times"}
									className="p-button-danger p-button-rounded mr-2"
									tooltipOptions={{ position: "top" }}
									tooltip="Click to De-Activate"
								/>
							) : (
								<Button
									onClick={(a) => activateHandler(e?.appointment?.user?.id)}
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi- pi-check"}
									className="p-button-success p-button-rounded mr-2"
									tooltipOptions={{ position: "top" }}
									tooltip="Click to Activate"
								/>
							)} */}
						</>
					)}
				></Column>
			</DataTable>

			<Dialog
				header={
					<>
						<i className="pi pi-pencil"></i>
						<span>{` Edit User -  ${selectedUser?.appointment?.surname || "Surname"}, ${selectedUser?.appointment?.firstName || "First Name"}  (${selectedUser?.email || "Email"})`}</span>
					</>
				}
				footer={
					<div>
						{activeIndex === 0 &&
							(permission?.actions?.includes(permissionLookUp.Create) ||
								permission?.actions?.includes(permissionLookUp.Create) ||
								permission?.actions?.includes(permissionLookUp.Delete)) && (
								<Button
									icon="pi pi-t"
									disabled={isValid()}
									label="Submit"
									onClick={(e) => {
										onUserGroupSelector();
									}}
									className="p-button-primary"
								/>
							)}
						<Button icon="pi pi-times-circle" label="Close" onClick={(e) => setShowEditUserForm(false)} className="p-button-danger" />
					</div>
				}
				draggable={false}
				visible={showEditUserForm}
				onHide={(e) => {
					setShowEditUserForm(false);
				}}
				style={{ width: "75%", height: "90%" }}
				onShow={() => {
					getDelimitations(selectedUser.userID);
					getGroups(selectedUser.userID);
					getOffices(selectedUser.userID);
				}}
			>
				<TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
					{/* <TabPanel header="Personal Details">
						<div className="grid">
							<div className="col-12  lg:col-4">
								<TextInput label="Name" value={selectedUser?.firstName} />
							</div>
							<div className="col-12  lg:col-4">
								<TextInput label="Surname" value={selectedUser?.surname} />
							</div>

							<div className="col-12  lg:col-4">
								<TextInput label="Other Names" value={selectedUser?.otherNames} />
							</div>

							<div className="col-12  lg:col-4">
								<TextInput label="ID Number" value={selectedUser?.idCardNumber} />
							</div>

							<div className="col-12  lg:col-4">
								<TextInput label="Contact Number" value={selectedUser?.phoneNumber} />
							</div>
							<div className="col-12  lg:col-4">
								<TextInput label="Email Address" value={selectedUser?.emailAddress} />
							</div>
						</div>
					</TabPanel> */}

					<TabPanel header="Groups">
						<ScreenLoader visible={loadingGroup} />
						<div className="grid" style={{ flex: 1 }}>
							<div className="col-12 lg:col-12">
								<div className="card">
									<Toast ref={toast} />

									<PickList
										showSourceControls={false}
										showTargetControls={false}
										loading={loadingGroup}
										dataKey="groupID"
										source={loadingGroup ? [] : systemGroupsList}
										target={loadingGroup ? [] : target}
										onChange={onUserGroupChange}
										itemTemplate={(item) => item.name}
										sourceHeader="Groups"
										targetHeader="Assigned Groups"
										sourceStyle={{ height: "30rem" }}
										targetStyle={{ height: "30rem" }}
									/>
								</div>
							</div>
						</div>
					</TabPanel>
					<TabPanel header="Demarcation">
						<Toast ref={toast} />
						<div className="grid" style={{ flex: 1 }}>
							<div className="col-12 lg:col-12">
								{(permission?.actions?.includes(permissionLookUp.Update) ||
									permission?.actions?.includes(permissionLookUp.Create)) && (
									<Button
										className="p-button-success"
										icon="pi pi-plus"
										label="Assign"
										onClick={(e) => {
											setShowRegistrionCentreSelector(true);
										}}
									/>
								)}
							</div>
							<div className="col-12 lg:col-12">
								<DataTable
									size="small"
									scrollable={true}
									value={delimitations}
									dataKey="id"
									className="datatable-responsive"
									currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
									emptyMessage="No delimitation(s) found."
									responsiveLayout="scroll"
									resizableColumns
									columnResizeMode="expand"
									filters={filters}
									filterDisplay="Name"
									globalFilterFields={["Name"]}
									loading={loading}
								>
									<Column field="districtName" header={changeLang.get("national_delimitation.district")}></Column>
									<Column field="constituencyName" header={changeLang.get("national_delimitation.constituency")}></Column>
									<Column field="pollingDivisionName" header={changeLang.get("national_delimitation.electoralDivision")}></Column>
									<Column field="registrationCentreName" header={changeLang.get("national_delimitation.votingCentre")}></Column>

									{permission?.actions?.includes(permissionLookUp.Delete) && (
										<Column
											field="actions"
											header="Actions"
											body={(e) => (
												<>
													<Button
														onClick={() => {
															confirmDeleteDelimitation(e, false);
														}}
														style={{ textAlign: "center", width: "30px", height: "30px" }}
														icon={"pi pi-trash"}
														className="p-button-danger p-button-rounded mr-2"
														tooltip="Click to delete"
													/>
												</>
											)}
										></Column>
									)}
								</DataTable>
								<RegistrationDelimitationSelector
									show={showRegistrionCentreSelector}
									selectedUser={selectedUser}
									userDelimitations={delimitations}
									onSubmit={(data) => onRegistrationCentreSelected(data)}
									onHide={() => setShowRegistrionCentreSelector(false)}
								/>
							</div>
						</div>
					</TabPanel>
					<TabPanel header="Offices">
						<Toast ref={toast} />
						<div className="grid" style={{ flex: 1 }}>
							<div className="col-12 lg:col-12">
								{(permission?.actions?.includes(permissionLookUp.Update) ||
									permission?.actions?.includes(permissionLookUp.Create)) && (
									<Button
										className="p-button-success"
										icon="pi pi-plus"
										label="Assign"
										// disabled={offices[0] == null ? true : false}
										onClick={(e) => {
											setShowOfficeSelector(true);
										}}
									/>
								)}
							</div>
							<div className="col-12 lg:col-12">
								<DataTable
									size="small"
									scrollable={true}
									value={offices}
									dataKey="id"
									className="datatable-responsive"
									currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
									emptyMessage="No delimitation(s) found."
									responsiveLayout="scroll"
									resizableColumns
									columnResizeMode="expand"
									filters={filters}
									filterDisplay="Name"
									globalFilterFields={["Name"]}
									loading={loading}
								>
									<Column field="name" header="Office"></Column>
									<Column field="startDate" body={(e) => formatDate(e.startDate)} header="Start Date"></Column>
									<Column field="endDate" body={(e) => formatDate(e.endDate)} header="End Date"></Column>
									<Column field="active" header="Status"></Column>

									{permission?.actions?.includes(permissionLookUp.Delete) && (
										<Column
											field="actions"
											header="Actions"
											body={(e) => (
												<>
													<Button
														onClick={() => {
															confirmDeleteOffice(e);
														}}
														style={{ textAlign: "center", width: "30px", height: "30px" }}
														icon={"pi pi-trash"}
														className="p-button-danger p-button-rounded mr-2"
														tooltip="Click to delete"
													/>
												</>
											)}
										></Column>
									)}
								</DataTable>
								<OfficeSelector
									show={showOfficeSelector}
									selectedUser={selectedUser}
									userDelimitations={delimitations}
									onSubmit={(data) => onOfficeSelectorSubmit(data)}
									onHide={() => setShowOfficeSelector(false)}
								
								/>
							</div>
						</div>
					</TabPanel>
				</TabView>
			</Dialog>
		</div>
	);
};
